import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody52.css';

import clientimg from '../images/case-study-client52.webp'
import outcome from '../images/outcome52.webp'

import sm1 from '../images/cs52so1.webp'
import sm2 from '../images/cs52so2.webp'


const Casestudybody52 = () => {

    return (
        <>
        <section className='casestudybody52-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A global consulting, investment advisory, and business analytics firm serving family offices, fund managers, advisors, and corporates worldwide. The firm provides specialized expertise across critical business areas, including business strategy, portfolio management, and transaction advisory</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>Employee documents were prepared manually from data spread across multiple sources, with no centralized workflow. This resulted in duplicated effort, limited status visibility, repeated follow-ups for approvals and signatures, difficulty handling bulk requests, fragmented document storage, and no consolidated audit trail. The organization needed a centralized platform to automate document generation, standardize approvals, support high-volume processing, and track every document through to employee acceptance</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody52-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Process Discovery & Stakeholder Alignment</h4>
                          <p>Conducted process discovery workshops to map the employee document lifecycle, gather business requirements, and validate workflows through an interactive prototype</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Data & Integration Architecture</h4>
                          <p>Established a centralized data model for employees, templates, roles, workflows, dispatch, acceptance, and audit, integrated with Zoho Analytics and OneDrive archiving</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Workflow & Access Governance</h4>
                          <p>Established role-based governance with structured approvals, delegated signatories, controlled distribution, and full process traceability</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Built-In quality Controls</h4>
                          <p>Implemented automated validation checks to ensure data accuracy, prevent duplicate processing, enforce approval policies, and maintain compliance</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Testing & User Acceptance</h4>
                          <p>Executed end-to-end functional, integration, security, and role-based access testing, followed by UAT to confirm quality and business alignment</p>
                        </div>

                        
                      </div>     
                          <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Deployment</h4>
                          <p>Deployed the solution in a controlled production environment, supported user onboarding, and ensured a smooth transition through post-deployment monitoring</p>
                        </div>

                        
                      </div>  

                  <div class="ai-section">

                    {/* <!-- Impact of AI --> */}
                    <div class="impact-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        Impact of AI
                      </h2>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~55%</span>
                        <span class="stat-label">
                          Faster<br />
                          Delivery Cycle
                        </span>
                      </div>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~80%</span>
                        <span class="stat-label">
                          Repetitive<br />
                          Dev Tasks<br />
                          Automated
                        </span>
                      </div>

                    </div>

                    {/* <!-- AI Integration --> */}
                    <div class="integration-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        AI-Integration
                      </h2>

                      <div class="integration-content">

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            HOW AI WAS USED IN DELIVERY
                          </h3>

                          <p class="column-description">
                            Claude Code was used across the development lifecycle
                            for code generation, testing, and documentation.
                            It sped up component creation, prototype refinement,
                            and test-case preparation, while keeping coding
                            patterns consistent and cutting repetitive effort.
                          </p>

                        </div>

                        {/* <!-- Delivery Benefits --> */}
                        <div class="integration-column delivery-benefits">

                          <h3 class="column-heading">
                            DELIVERY BENEFITS
                          </h3>

                          <ul class="benefits-list">
                            <li>Faster build of templates, workflows, and UI components</li>
                            <li>Quicker prototype iterations during stakeholder validation</li>
                            <li>Wider test coverage from AI-prepared test cases</li>
                            <li>Consistent code patterns and current technical documentation</li>
                            <li>Less repetitive coding, more time on business logic</li>
                          </ul>

                        </div>

                      </div>
                    </div>

                  </div>
                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>

           


          </Container>
        </section>

    
        <section className='casestudybody52-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The HR Document Automation Platform streamlined the entire employee document lifecycle through automated workflows, standardized templates, digital approvals, and centralized governance, resulting in improved efficiency, compliance, visibility, and employee experience</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody52
